import { showCartNotice } from "./cart-notice";

export const setupWapoPopupErrorNotice = () => {
  jQuery(document).ajaxSuccess((event, xhr, settings) => {
    const data = settings.data;
    const isPopupSave =
      (typeof data === "string" && data.includes("action=ywapo_update_addons_on_cart_item")) ||
      (data && typeof data === "object" && data.action === "ywapo_update_addons_on_cart_item");

    if (!isPopupSave) return;

    let response;
    try {
      response = JSON.parse(xhr.responseText);
    } catch (e) {
      return;
    }

    if (response && response.success === false && response.error) {
      showCartNotice(response.error, "woocommerce-error");
    }
  });
};
